<template>
  <div>
    <m-chat ref="chat" :entity="entity" :entity-id="entityId" :can-edit="canEdit" @close="updateCount" />
    <c-button
      v-if="visible"
      size="small"
      icon="comment"
      :label="commentsLabel"
      :tooltip="{
        text: 'Комментарий',
        activeText: 'Комментарий',
      }"
      @click="openChat"
    />
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import ChatModal from "@/components/chat/ChatModal";
import { GET_MESSAGES_ACTION } from "@/components/chat/api";
import { wordForm } from "@/utils/text/wordForm";

export default {
  components: { CButton, "m-chat": ChatModal },
  props: ["entity", "entityId", "canEdit", "hideEmpty"],
  data() {
    return {
      loading: false,
      visible: false,
      commentsCount: 0,
    };
  },
  computed: {
    commentsLabel() {
      if (this.commentsCount === 0) return "Нет комментариев";

      const form = wordForm(this.commentsCount, ["комментарий", "комментария", "комментариев"]);
      return `${this.commentsCount} ${form}`;
    },
  },
  watch: {
    hideEmpty(value) {
      this.visible = this.commentsCount > 0 || !value;
    },
    commentsCount(value) {
      console.log("commentsCount", value, this.hideEmpty);
      this.visible = value > 0 || !this.hideEmpty;
    },
  },
  created() {
    this.loading = true;
    this.updateCount().then(() => {
      if (this.commentsCount > 0 || !this.hideEmpty) this.visible = true;
      this.loading = false;
    });
  },
  methods: {
    updateCount() {

      this.loading = true;
      return this.$store
        .dispatch(GET_MESSAGES_ACTION, {
          entity: this.entity,
          entityId: this.entityId,
        })
        .then((res) => {
          this.commentsCount = res.filter((item) => !item.is_delete).length;
          this.loading = false;
        });
    },
    openChat() {
      this.$refs.chat.open();
    },
  },
};
</script>
